// |-- Built-in Dependencies --|
import React, { useState } from "react";

// |-- External Dependencies --|
import { useDispatch, useSelector } from "react-redux";

// |-- Internal Dependencies --|
import DispositionListView from "../../Components/DispositionListView";

// |-- Redux --|
import { RootState, AppDispatch } from "src/redux/store";
import {
  setSelectedLocationCountry,
  setSearchValue,
} from "src/redux/slices/DispositionLevelOneSlice";
import {
  setFilterValue,
  setSelctedLocationState,
} from "src/redux/slices/DispositionLevelTwoSlice";
import { useDeleteDispositionLevelOneMutation } from "src/services/DispositionLevelOneServices";
import { showToast } from "src/utils/showToaster";
import EditDispositionLevelOneFormWrapper from "../Edit/EditDispositionLevelOneFormWrapper";
import { isCheckActionsPermission } from "src/helpers/userAccessFun";
import { UserModuleActionTypes, UserModuleNameTypes } from "src/models/userAccess/UserAccess.model";

// |-- Types --|
type Props = {
  contries: any[];
  items: any;
  onAddNew: () => void;
};

const DispositionLevelOneListing = ({ contries, items, onAddNew }: Props) => {
  const [setselectedDispositionFirstId, setsetselectedDispositionFirstId] =
    useState<string>("");
  const [isOpenEditForm, setIsOpenEditForm] = useState(false);

  const [deleteDispositionLevelOne] = useDeleteDispositionLevelOneMutation();

  const dispatch = useDispatch<AppDispatch>();

  const { selectedLocationCountries, searchValue }: any = useSelector(
    (state: RootState) => state.dispositionLevelOne
  );

  function handleCountryClick(newValue: any) {
    if (selectedLocationCountries?.value === newValue.value) {
      dispatch(setSelectedLocationCountry(null));
      dispatch(setSelctedLocationState(null));
    } else {
      dispatch(setSelectedLocationCountry(newValue));
      dispatch(setFilterValue(newValue.value));
    }
  }

  return (
    <>
      <DispositionListView
        listHeading="Disposition One"
        listData={contries}
        searchValue={searchValue}
        OnSearchChange={(newValue) => dispatch(setSearchValue(newValue))}
        hideAddButton={!isCheckActionsPermission({
          moduleName: UserModuleNameTypes.DISPOSITION,
          actionName: UserModuleActionTypes.DISPOSITION_ONE_ADD,
        })}
        onAddClick={() => {
          onAddNew();
        }}
        onListItemClick={(newValue) => {
          handleCountryClick(newValue);
        }}
        onOuterGetActionDeleteClick={(value: {
          label: string;
          value: string;
        }) => {
          deleteDispositionLevelOne(value?.value).then((res: any) => {
            if (res?.error) {
              showToast("error", res?.error?.data?.message);
            } else {
              if (res?.data?.status) {
                showToast("success", "delete successfully");
                setFilterValue("");
              } else {
                showToast("error", res?.data?.message);
              }
            }
          });
        }}
        onOuterGetActionEditClick={(value) => {
          setIsOpenEditForm(true);
          setsetselectedDispositionFirstId(value?.value);
        }}
        disabled={false}
      />

      {isOpenEditForm ? (
        <EditDispositionLevelOneFormWrapper
          dispositionLevelFirstId={setselectedDispositionFirstId}
          onClose={() => setIsOpenEditForm(false)}
        />
      ) : null}
    </>
  );
};

export default DispositionLevelOneListing;
